import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isAuthenticated } from './authStore';

/**
 * Route guard ("auth middleware").
 *
 * Wrap any private route with this component: if the visitor is not logged in
 * they are redirected to `/authenticate?tab=login`. The originally requested
 * location is passed along in router state so the login flow can send the user
 * back where they were headed once that flow exists.
 */
function RequireAuth({ children }) {
  const location = useLocation();

  if (!isAuthenticated()) {
    return (
      <Navigate
        to="/authenticate?tab=login"
        replace
        state={{ from: location }}
      />
    );
  }

  return children;
}

export default RequireAuth;
